// extracted by mini-css-extract-plugin
var _1 = "LB59Y";
var _2 = "d0hhL";
export { _1 as "base", _2 as "icon-only" }
